import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgxDatatableWrapperComponent } from 'src/app/components/_components/ngxDatatableWrapper/ngx-datatable-wrapper.component';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ProvvedimentoService } from '../../../services';
import { StoricoDettaglioComponent } from "../../../components/storicoDettaglio/storico-dettaglio.component";

@Component({
    selector: 'storico-provvedimento-component',
    templateUrl: './storico-provvedimento.component.html',
    styleUrls: ['./storico-provvedimento.component.css']
})
export class StoricoProvvedimentoComponent
    implements OnInit {

    modalRef: BsModalRef;

    _isInModal: boolean = false;
    @Input()
    set isInModal(value: boolean) {
        this._isInModal = value;
    }
    get isInModal() { return this._isInModal; }


    _provvedimentoId: number;
    @Input()
    set provvedimentoId(value: number) {
        this._provvedimentoId = value;
    }

    get provvedimentoId() {
        return this._provvedimentoId;
    }


    loading: boolean = true;

    @ViewChild('btnDetailTemplate', { static: true })
    public btnDetailTemplate: TemplateRef<any>;

    @ViewChild('tipologiaValueTemplate', { static: true })
    public tipologiaValueTemplate: TemplateRef<any>;


    @ViewChild('ngxDatatableWrapper')
    ngxDatatableWrapper: NgxDatatableWrapperComponent;

    dtOptions: any;

    columns = [
        {
            name: '', prop: 'id', sortable: true, filtrable: false, maxWidth: 0, width: 0, visible: false
            // 'buttonsTemplate'
        }

        , {
            name: 'data'
            , prop: 'date'
            , sortable: true
            , filtrable: true
            , minWidth: 160
            , cellTemplate: 'dateTimeValueTemplate'
            , flexGrow: 2
        }
        , {
            name: 'tipologia'
            , prop: 'action'
            , sortable: true
            , filtrable: true
            , cellTemplate: 'tipologiaValueTemplate'
            , minWidth: 140
            , flexGrow: 2

        }
        , {
            name: 'descrizione'
            , prop: 'actionDescription'
            , sortable: true
            , filtrable: true
            , minWidth: 200
            , flexGrow: 5
        }

        , {
            name: 'utente'
            , prop: 'username'
            , sortable: true
            , filtrable: true
            , minWidth: 140
            , flexGrow: 3
        }

        , {
            name: 'dettaglio'
            , prop: 'id'
            , sortable: false
            , filtrable: false
            , cellTemplate: 'btnDetailTemplate'// 'buttonsTemplate'
            , minWidth: 60
            , flexGrow: 1

        }
    ];
    templateList = [];

    constructor(private provvedimentoService: ProvvedimentoService
        , private modalService: BsModalService
    ) {
        this.dtOptions = {
            rows: []
            , columns: this.columns
            , columnMode: ColumnMode.flex
            , headerHeight: "50"
            , footerHeight: "50"
            , rowHeight: "auto"
            , externalSorting: true// true
            , loadingIndicator: 'loading'
            , class: "bootstrap"
            , summaryRow: true
            , summaryPosition: "'bottom'"
            , externalPaging: true// true
            , count: 0
            , offset: 0
            , limit: 10
            , serverSide: true
            , scrollbarH: "true"
            , ajax: this.getStorico
            , sorts: [{ dir: 'desc', prop: 'date' }]
        };
    }
    ngOnInit(): void {
        console.log(this._provvedimentoId);
        this.templateList = [
            { name: 'btnDetailTemplate', template: this.btnDetailTemplate }
            , { name: 'tipologiaValueTemplate', template: this.tipologiaValueTemplate }
        ];
        window.scroll(0, 0);
    }

    reloadAllData() {
        this.loading = true;
        this.ngxDatatableWrapper.gridModel.data = [];
        this.ngxDatatableWrapper.refresh();
    }

    getStorico = (dataTablesParameters: any, callback: any) => {
        let that = this;
        if (!that._provvedimentoId) return;
        this.provvedimentoService.getStoricoDt(that._provvedimentoId, dataTablesParameters)
            .subscribe(resp => {
                callback(resp)
                that.loading = false;
            });
    }

    @Input()
    gotoBtnOptions: any;

    @Output()
    gotoBtnFunction: EventEmitter<boolean> = new EventEmitter();
    gotoBackBtnClick() {
        this.gotoBtnFunction.emit(true);
    }

    onDetail(row) {
        let modalDefinition = {
            pageTitle: 'Dettaglio storico - provvedimento'
        };
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
            class: 'modal-xl'
        };
        const initialState = { modalDefinition: modalDefinition,id:row.id,what:'provvedimento',provvedimentoId:this.provvedimentoId };

        this.modalRef = this.modalService.show(StoricoDettaglioComponent, Object.assign({}, config, { initialState }));
    }
}
